import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileText, Headphones, Download } from 'lucide-react';
export function KitContentsSection() {
  const contents = [{
    icon: FileText,
    text: 'Guía en PDF: 7 días de journaling rápido (3 preguntas por día).',
    color: 'bg-blue-50 text-blue-600'
  }, {
    icon: Headphones,
    text: '3 audios guiados para acompañar cada paso.',
    color: 'bg-purple-50 text-purple-600'
  }, {
    icon: Download,
    text: 'Plantillas editables para descargar tus pensamientos en minutos.',
    color: 'bg-green-50 text-green-600'
  }];
  return <section className="py-20 px-4 bg-[#FAF3EB]" data-id="element-60">
      <div className="container max-w-5xl mx-auto" data-id="element-61">
        <FadeIn data-id="element-62">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#3D3229] mb-16" data-id="element-63">
            ¿Qué vas a recibir?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-64">
          {contents.map((item, index) => <FadeIn key={index} delay={index * 0.2} className="h-full" data-id="element-65">
              <div className="bg-white p-8 rounded-2xl shadow-sm h-full flex flex-col items-center text-center border border-[#3D3229]/5 hover:shadow-md transition-shadow duration-300" data-id="element-66">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center mb-6 bg-[#FDF8F3] text-[#C4703F]`} data-id="element-67">
                  <item.icon className="w-8 h-8" data-id="element-68" />
                </div>
                <p className="text-lg text-[#3D3229]/80 font-medium leading-relaxed" data-id="element-69">
                  {item.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}